import React, { ComponentProps, useEffect } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { weappSDK } from '@weapp/utils';
import { mainHost } from '../../utils';

function QuickCreateOpen(props: RouteComponentProps & ComponentProps<any>) {

  useEffect(() => {
    const params = {
        url:mainHost() + "/mobile/uk/quickCreate", // 要打开链接的地址
        openType: 2, // 打开方式 1:当前窗口 2:新窗口 3:系统默认浏览器
        hideNavegation: 1, //打开的页面是否隐藏导航栏，1表示隐藏，0表示不隐藏，默认为0。另外如果url中含有app_nav_hide=1参数也会隐藏导航头部，适用于所有页面
        success: () => {}
    }
    weappSDK.checkApi('openLink').then(() => {
        weappSDK.exec('openLink', params).then(() => {
  
        }).catch((err: any) => {
          console.log("### js sdk error..." + err);
        })
      }).catch(() => {
        console.log("### js sdk check error...");
      })
  }, [])
  
  return (
    <></>
  )
}

export default withRouter(QuickCreateOpen);